(() => {
  function init(root) {
    root.querySelectorAll('[data-hs-line-shelf]').forEach(shelf => {
      if (shelf.dataset.tabsReady) return;
      const list = shelf.querySelector('[role="tablist"]');
      const panel = shelf.querySelector('[role="tabpanel"]');
      if (!list || !panel) return;
      shelf.dataset.tabsReady = 'true';
      const cards = [...panel.querySelectorAll('[data-line-product]')];
      const allTabs = [...list.querySelectorAll('[role="tab"]')];
      const matches = (card, key) => key === 'featured' ? card.dataset.featured === 'true' : card.dataset.lineProduct === key;
      allTabs.forEach(tab => { tab.hidden = !cards.some(card => matches(card, tab.dataset.line)); });
      const tabs = allTabs.filter(tab => !tab.hidden);
      if (!tabs.length) return;
      const cursor = document.createElement('span');
      cursor.className = 'hs-line-tabs__cursor';
      cursor.setAttribute('aria-hidden', 'true');
      list.prepend(cursor);
      function moveCursor(tab) {
        if (!tab || tab.hidden) return;
        list.style.setProperty('--hs-tab-left', `${tab.offsetLeft}px`);
        list.style.setProperty('--hs-tab-top', `${tab.offsetTop}px`);
        list.style.setProperty('--hs-tab-width', `${tab.offsetWidth}px`);
        list.style.setProperty('--hs-tab-height', `${tab.offsetHeight}px`);
        list.classList.add('is-slide-ready');
      }
      function selectedTab() {
        return tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || tabs[0];
      }
      function select(tab) {
        allTabs.forEach(item => { item.setAttribute('aria-selected', String(item === tab)); item.tabIndex = item === tab ? 0 : -1; });
        cards.forEach(card => { card.hidden = !matches(card, tab.dataset.line); });
        panel.setAttribute('aria-labelledby', tab.id);
        moveCursor(tab);
        const swiper = panel.swiper;
        if (swiper && !swiper.destroyed) { swiper.update(); swiper.slideTo(0, 0); swiper.update(); }
        panel.scrollLeft = 0;
        document.dispatchEvent(new CustomEvent('hs:carousel-ready'));
      }
      list.hidden = false;
      const hint = document.createElement('div');
      hint.className = 'hs-line-scroll-hint';
      hint.setAttribute('aria-hidden', 'true');
      const markers = Array.from({ length: 3 }, () => hint.appendChild(document.createElement('span')));
      list.after(hint);
      function updateHint() {
        const range = list.scrollWidth - list.clientWidth;
        hint.hidden = range <= 2;
        const position = range > 0 ? Math.max(0, Math.min(1, list.scrollLeft / range)) : 0;
        const active = Math.round(position * (markers.length - 1));
        markers.forEach((marker, index) => marker.classList.toggle('is-active', index === active));
      }
      list.addEventListener('scroll', updateHint, { passive: true });
      const hintResize = new ResizeObserver(updateHint);
      hintResize.observe(list);
      const cursorResize = new ResizeObserver(() => moveCursor(selectedTab()));
      cursorResize.observe(list);
      updateHint();
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(shelf)) { hintResize.disconnect(); cursorResize.disconnect(); }
      });
      list.addEventListener('pointerover', event => {
        const tab = event.target.closest('[role="tab"]');
        if (tab && list.contains(tab)) moveCursor(tab);
      });
      list.addEventListener('pointerleave', () => moveCursor(selectedTab()));
      list.addEventListener('focusin', event => {
        const tab = event.target.closest('[role="tab"]');
        if (tab && list.contains(tab)) moveCursor(tab);
      });
      list.addEventListener('focusout', event => {
        if (!list.contains(event.relatedTarget)) moveCursor(selectedTab());
      });
      list.addEventListener('click', event => {
        const tab = event.target.closest('[role="tab"]');
        if (tab && list.contains(tab)) select(tab);
      });
      list.addEventListener('keydown', event => {
        const index = tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault(); tabs[next].focus(); select(tabs[next]);
      });
      select(tabs[0]);
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
